"use client";

import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";

import styles from "./BreakingCard.module.scss";
import { useArticleModalStore } from "../../store/useArticleModalStore";

const BreakingCard = ({
  articleLink: { articleId, slug },
  externalLink,
  vignette,
  title,
}: {
  articleLink: { articleId: string; slug: string };
  externalLink?: string;
  title: string;
  vignette?: string;
}) => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const { openModal } = useArticleModalStore();

  if (externalLink) {
    return (
      <div className={styles.breakingCard}>
        <a
          href={externalLink}
          className={styles.link}
          rel="noopener noreferrer"
          target="_blank"
        >
          <span className={styles.separator}>●</span>
          <div>
            {vignette && <span className={styles.vignette}>{vignette}</span>}
            <span className={styles.title}>{title}</span>
          </div>
        </a>
      </div>
    );
  }

  return (
    <div className={styles.breakingCard}>
      <Link
        href={`/${slug}/a/${articleId}`}
        className={styles.link}
        prefetch={true}
        scroll={false}
        onNavigate={() =>
          openModal(
            searchParams.size > 0 ? `${pathname}?${searchParams}` : pathname,
          )
        }
      >
        <span className={styles.separator}>●</span>
        <div>
          {vignette && <span className={styles.vignette}>{vignette}</span>}
          <span className={styles.title}>{title}</span>
        </div>
      </Link>
    </div>
  );
};

export { BreakingCard };
